import React from 'react'
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';


const Links = ({
  mutators
}) => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
        Adresy www, media społecznościowe
      </Typography> 
    )}
    subtitle={(
      <Typography component="p">
        Możesz dodać linki do Twojej strony www, profilu na LinkedIn lub innym portalu społecznościowym.
      </Typography>
    )}
  >
    <MultiFieldsGroup
      name='links'
      mutators={mutators}
      fieldToPreview='link'
      renderFieldsGroup={(name, index) => (
        <>
          <InputLabel shrink>
          Link
          </InputLabel>
          <TextField
            name={`${name}.link`}
            type="text"
          />
        </>
      )}
    />
  </FormSection>
)

export default Links